import React from "react";
import { Row, Typography, Form, Col, Divider, Select, Input, InputNumber } from "antd";
import { BOM } from "../../../../../services/definedMethod";
const { Title, Text } = Typography;

const PostingControlsForm = (props) => {
  const { onFinish, form, formData, templateData } = props;
  return (
    <Form layout="vertical" onFinish={onFinish} form={form} initialValues={formData}>
      <Divider orientation="left" orientationMargin="0">
        <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
          Posting Controls
        </Title>
      </Divider>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="postingAllowed"
            label={<Text strong>Posting Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Posting Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Posting Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="debitAllowed"
            label={<Text strong>Debit Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Debit Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Debit Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="creditAllowed"
            label={<Text strong>Credit Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Credit Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Credit Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="maxTransactionLimit"
            label={<Text strong>Maximum Transaction Limit</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Maximum Transaction Limit"),
              },
            ]}
          >
            <InputNumber
              // type="number"
              min={0}
              placeholder={BOM.handlePlaceholderMsg("Maximum Transaction Limit")}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            name="batchPostingAllowed"
            label={<Text strong>Batch Posting Allowed</Text>}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld("Batch Posting Allowed"),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg("Batch Posting Allowed")}
              options={templateData.yesOrNo}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default PostingControlsForm;
